import { render, staticRenderFns } from "./GestorProfile.vue?vue&type=template&id=2c48e360"
import script from "./GestorProfile.vue?vue&type=script&lang=js"
export * from "./GestorProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports